import {
  PiUserListFill,
  PiUserSquareDuotone,
  PiShoppingBagDuotone,
  PiGearSixDuotone,
  PiBasketDuotone,
  PiShoppingCartDuotone,
} from "react-icons/pi";
import { MdOutlineInventory, MdOutlineReviews } from "react-icons/md";
import { BiCartDownload } from "react-icons/bi";
import routes from "./routes";
import roleAndPermissions from "./permissions";
import { BiSolidDiscount } from "react-icons/bi";
import { TbGiftCard, TbTruckReturn } from "react-icons/tb";
import { GiAutoRepair } from "react-icons/gi";
import { RiFileChartLine, RiRefund2Line, RiExchangeBoxLine, RiDashboardLine, RiArrowGoBackLine, RiInboxArchiveLine, RiRefreshLine, RiToolsLine, RiFileList3Line, RiCarWashingLine } from "react-icons/ri";

const menus = [
  {
    label: "Items",
    requiredPermissions: [
      roleAndPermissions.ProductManagement.create,
      roleAndPermissions.ProductManagement.update,
      roleAndPermissions.ProductManagement.delete,
      roleAndPermissions.ProductManagement.view,
      roleAndPermissions.ProductReviews.create,
      roleAndPermissions.ProductReviews.update,
      roleAndPermissions.ProductReviews.delete,
      roleAndPermissions.ProductReviews.view,
      roleAndPermissions.ProductCategory.create,
      roleAndPermissions.ProductCategory.update,
      roleAndPermissions.ProductCategory.delete,
      roleAndPermissions.ProductCategory.view,
      roleAndPermissions.ProductCatalog.create,
      roleAndPermissions.ProductCatalog.update,
      roleAndPermissions.ProductCatalog.delete,
      roleAndPermissions.ProductCatalog.view,
      roleAndPermissions.ProductBrand.create,
      roleAndPermissions.ProductBrand.update,
      roleAndPermissions.ProductBrand.delete,
      roleAndPermissions.ProductBrand.view,
      roleAndPermissions.ProductCompatibility.create,
      roleAndPermissions.ProductCompatibility.update,
      roleAndPermissions.ProductCompatibility.delete,
      roleAndPermissions.ProductCompatibility.view,
      roleAndPermissions.OrderAddOn.create,
      roleAndPermissions.OrderAddOn.update,
      roleAndPermissions.OrderAddOn.delete,
      roleAndPermissions.OrderAddOn.view,
      roleAndPermissions.GiftCardManagement.create,
      roleAndPermissions.GiftCardManagement.update,
      roleAndPermissions.GiftCardManagement.delete,
      roleAndPermissions.GiftCardManagement.view,
      roleAndPermissions.DiscountManagement.create,
      roleAndPermissions.DiscountManagement.update,
      roleAndPermissions.DiscountManagement.delete,
      roleAndPermissions.DiscountManagement.view,
    ],
    type: "group",
    children: [
      {
        key: routes.PRODUCTS.path,
        label: "Products",
        icon: <PiShoppingBagDuotone />,
        requiredPermissions: [
          roleAndPermissions.ProductManagement.create,
          roleAndPermissions.ProductManagement.update,
          roleAndPermissions.ProductManagement.delete,
          roleAndPermissions.ProductManagement.view,
        ],
      },
      {
        key: routes.PRODUCTSREVIEWS.path,
        label: "Products Reviews",
        icon: <MdOutlineReviews />,
        requiredPermissions: [
          roleAndPermissions.ProductReviews.create,
          roleAndPermissions.ProductReviews.update,
          roleAndPermissions.ProductReviews.delete,
          roleAndPermissions.ProductReviews.view,
        ],
      },
      {
        key: "product-meta",
        label: "Settings",
        icon: <PiGearSixDuotone />,
        requiredPermissions: [
          roleAndPermissions.ProductCategory.create,
          roleAndPermissions.ProductCategory.update,
          roleAndPermissions.ProductCategory.delete,
          roleAndPermissions.ProductCategory.view,
          roleAndPermissions.ProductCatalog.create,
          roleAndPermissions.ProductCatalog.update,
          roleAndPermissions.ProductCatalog.delete,
          roleAndPermissions.ProductCatalog.view,
          roleAndPermissions.ProductBrand.create,
          roleAndPermissions.ProductBrand.update,
          roleAndPermissions.ProductBrand.delete,
          roleAndPermissions.ProductBrand.view,
          roleAndPermissions.ProductCompatibility.create,
          roleAndPermissions.ProductCompatibility.update,
          roleAndPermissions.ProductCompatibility.delete,
          roleAndPermissions.ProductCompatibility.view,
          roleAndPermissions.OrderAddOn.create,
          roleAndPermissions.OrderAddOn.update,
          roleAndPermissions.OrderAddOn.delete,
          roleAndPermissions.OrderAddOn.view,
          roleAndPermissions.ProductAttribute.create,
          roleAndPermissions.ProductAttribute.update,
          roleAndPermissions.ProductAttribute.delete,
          roleAndPermissions.ProductAttribute.view,
        ],
        labelOnly: true,
        children: [
          {
            key: routes.PRODUCT_ATTRIBUTE.path,
            label: "Attributes",
            requiredPermissions: [
              roleAndPermissions.ProductAttribute.create,
              roleAndPermissions.ProductAttribute.update,
              roleAndPermissions.ProductAttribute.delete,
              roleAndPermissions.ProductAttribute.view,
            ],
            openMenuKeys: ["product-meta"],
          },
          {
            key: routes.PRODUCT_CATEGORY.path,
            label: "Categories",
            requiredPermissions: [
              roleAndPermissions.ProductCategory.create,
              roleAndPermissions.ProductCategory.update,
              roleAndPermissions.ProductCategory.delete,
              roleAndPermissions.ProductCategory.view,
            ],
            openMenuKeys: ["product-meta"],
          },
          {
            key: routes.PRODUCT_CATALOG.path,
            label: "Catalogs",
            requiredPermissions: [
              roleAndPermissions.ProductCatalog.create,
              roleAndPermissions.ProductCatalog.update,
              roleAndPermissions.ProductCatalog.delete,
              roleAndPermissions.ProductCatalog.view,
            ],
            openMenuKeys: ["product-meta"],
          },
          {
            key: routes.PRODUCT_BRAND.path,
            label: "Brands",
            requiredPermissions: [
              roleAndPermissions.ProductBrand.create,
              roleAndPermissions.ProductBrand.update,
              roleAndPermissions.ProductBrand.delete,
              roleAndPermissions.ProductBrand.view,
            ],
            openMenuKeys: ["product-meta"],
          },
          {
            key: routes.PRODUCT_COMPATIBILITY.path,
            label: "Compatibility",
            requiredPermissions: [
              roleAndPermissions.ProductCompatibility.create,
              roleAndPermissions.ProductCompatibility.update,
              roleAndPermissions.ProductCompatibility.delete,
              roleAndPermissions.ProductCompatibility.view,
            ],
            openMenuKeys: ["product-meta"],
          },
          {
            key: routes.ORDERS_ADDON.path,
            label: "Add-ons",
            requiredPermissions: [
              roleAndPermissions.OrderAddOn.create,
              roleAndPermissions.OrderAddOn.update,
              roleAndPermissions.OrderAddOn.delete,
              roleAndPermissions.OrderAddOn.view,
            ],
          },
        ],
      },
      {
        key: routes.GIFT_CARD_LIST.path,
        label: "Gift Card",
        icon: <TbGiftCard />,
        requiredPermissions: [
          roleAndPermissions.GiftCardManagement.create,
          roleAndPermissions.GiftCardManagement.update,
          roleAndPermissions.GiftCardManagement.delete,
          roleAndPermissions.GiftCardManagement.view,
        ],
      },
      {
        key: routes.DISCOUNTS.path,
        label: "Discounts",
        icon: <BiSolidDiscount />,
        requiredPermissions: [
          roleAndPermissions.DiscountManagement.create,
          roleAndPermissions.DiscountManagement.update,
          roleAndPermissions.DiscountManagement.delete,
          roleAndPermissions.DiscountManagement.view,
        ],
      },
    ],
  },
  {
    icon: <PiUserListFill />,
    label: "Purchase",
    requiredPermissions: [
      roleAndPermissions.Vendor.create,
      roleAndPermissions.Vendor.update,
      roleAndPermissions.Vendor.delete,
      roleAndPermissions.Vendor.view,
    ],
    type: "group",
    children: [
      {
        key: routes.VENDORS.path,
        icon: <PiBasketDuotone />,
        label: "Vendors",
        requiredPermissions: [
          roleAndPermissions.Vendor.create,
          roleAndPermissions.Vendor.update,
          roleAndPermissions.Vendor.delete,
          roleAndPermissions.Vendor.view,
        ],
      },
    ],
  },
  {
    label: "Sales",
    requiredPermissions: [
      roleAndPermissions.CustomerManagement.view,
      roleAndPermissions.CustomerManagement.create,
      roleAndPermissions.CustomerManagement.update,
      roleAndPermissions.CustomerManagement.delete,
      roleAndPermissions.AbandonedCheckouts.create,
      roleAndPermissions.AbandonedCheckouts.update,
      roleAndPermissions.AbandonedCheckouts.delete,
      roleAndPermissions.AbandonedCheckouts.view,
      roleAndPermissions.Refunds.view,
      roleAndPermissions.Order.create,
      roleAndPermissions.Order.update,
      roleAndPermissions.Order.delete,
      roleAndPermissions.Order.view,
    ],
    type: "group",
    children: [
      {
        key: routes.CUSTOMERS.path,
        icon: <PiUserSquareDuotone />,
        label: "Customers",
        requiredPermissions: [
          roleAndPermissions.CustomerManagement.view,
          roleAndPermissions.CustomerManagement.create,
          roleAndPermissions.CustomerManagement.update,
          roleAndPermissions.CustomerManagement.delete,
        ],
      },
      {
        key: routes.ORDERS.path,
        icon: <PiShoppingCartDuotone />,
        label: "Orders",
        requiredPermissions: [
          roleAndPermissions.Order.create,
          roleAndPermissions.Order.update,
          roleAndPermissions.Order.delete,
          roleAndPermissions.Order.view,
        ],
      },
      {
        key: routes.VIEW_REFUNDS.path,
        icon: <RiRefund2Line />,
        label: "Refunds",
        requiredPermissions: [roleAndPermissions.Refunds.view],
      },
      {
        key: routes.ABANDONEDCHECKOUTS.path,
        icon: <BiCartDownload />,
        label: "Abandoned Checkouts",
        requiredPermissions: [
          roleAndPermissions.AbandonedCheckouts.view,
          roleAndPermissions.AbandonedCheckouts.create,
          roleAndPermissions.AbandonedCheckouts.update,
          roleAndPermissions.AbandonedCheckouts.delete,
        ],
      },
    ],
  },
  // {
  //   icon: <RiExchangeBoxLine />,
  //   label: "Return Operations",
  //   requiredPermissions: [
  //     roleAndPermissions.MiddlewareReturns.view,
  //     roleAndPermissions.MiddlewareReturns.create,
  //     roleAndPermissions.MiddlewareReturns.update,
  //     roleAndPermissions.MiddlewareReceives.view,
  //     roleAndPermissions.MiddlewareReceives.update,
  //     roleAndPermissions.MiddlewareReceives.submit,
  //     roleAndPermissions.MiddlewareRefundSync.view,
  //     roleAndPermissions.MiddlewareRefundSync.resync,
  //   ],
  //   type: "group",
  //   children: [
  //     {
  //       key: routes.RETURN_OPERATIONS_DASHBOARD.path,
  //       icon: <RiDashboardLine />,
  //       label: "Overview",
  //       requiredPermissions: [
  //         roleAndPermissions.MiddlewareReturns.view,
  //         roleAndPermissions.MiddlewareReceives.view,
  //         roleAndPermissions.MiddlewareRefundSync.view,
  //       ],
  //     },
  //     {
  //       key: routes.RETURN_OPERATIONS_RETURNS.path,
  //       icon: <RiArrowGoBackLine />,
  //       label: "Returns",
  //       requiredPermissions: [roleAndPermissions.MiddlewareReturns.view],
  //     },
  //     {
  //       key: routes.RETURN_OPERATIONS_RECEIVES.path,
  //       icon: <RiInboxArchiveLine />,
  //       label: "Receives",
  //       requiredPermissions: [roleAndPermissions.MiddlewareReceives.view],
  //     },
  //     {
  //       key: routes.RETURN_OPERATIONS_REFUND_SYNC.path,
  //       icon: <RiRefreshLine />,
  //       label: "Refund Sync",
  //       requiredPermissions: [roleAndPermissions.MiddlewareRefundSync.view],
  //     },
  //   ],
  // },
  // {
  //   icon: <RiCarWashingLine />,
  //   label: "Repair Orders",
  //   requiredPermissions: [
  //     roleAndPermissions.RepairOrders.view,
  //     roleAndPermissions.RepairOrders.promote,
  //     roleAndPermissions.RepairOrders.retry,
  //     roleAndPermissions.RepairIncomingReceives.view,
  //     roleAndPermissions.RepairIncomingReceives.submit,
  //     roleAndPermissions.RepairIncomingReceives.ensure,
  //     roleAndPermissions.RepairServiceOrders.view,
  //     roleAndPermissions.RepairServiceOrders.update,
  //   ],
  //   type: "group",
  //   children: [
  //     {
  //       key: routes.REPAIR_ORDERS_DASHBOARD.path,
  //       icon: <RiDashboardLine />,
  //       label: "Overview",
  //       requiredPermissions: [
  //         roleAndPermissions.RepairOrders.view,
  //         roleAndPermissions.RepairIncomingReceives.view,
  //         roleAndPermissions.RepairServiceOrders.view,
  //       ],
  //     },
  //     {
  //       key: routes.REPAIR_ORDERS_LIST.path,
  //       icon: <RiFileList3Line />,
  //       label: "Orders",
  //       requiredPermissions: [roleAndPermissions.RepairOrders.view],
  //     },
  //     {
  //       key: routes.REPAIR_ORDERS_INCOMING.path,
  //       icon: <RiInboxArchiveLine />,
  //       label: "Incoming Receives",
  //       requiredPermissions: [roleAndPermissions.RepairIncomingReceives.view],
  //     },
  //     {
  //       key: routes.REPAIR_ORDERS_SERVICE.path,
  //       icon: <RiToolsLine />,
  //       label: "Service Orders",
  //       requiredPermissions: [roleAndPermissions.RepairServiceOrders.view],
  //     },
  //   ],
  // },
  {
    icon: <RiCarWashingLine />,
    label: "Middleware Operations",
    requiredPermissions: [
      roleAndPermissions.MiddlewareReturns.view,
      roleAndPermissions.MiddlewareReturns.create,
      roleAndPermissions.MiddlewareReturns.update,
      roleAndPermissions.MiddlewareReceives.view,
      roleAndPermissions.MiddlewareReceives.update,
      roleAndPermissions.MiddlewareReceives.submit,
      roleAndPermissions.MiddlewareRefundSync.view,
      roleAndPermissions.MiddlewareRefundSync.resync,
      roleAndPermissions.RepairOrders.view,
      roleAndPermissions.RepairOrders.promote,
      roleAndPermissions.RepairOrders.retry,
      roleAndPermissions.RepairIncomingReceives.view,
      roleAndPermissions.RepairIncomingReceives.submit,
      roleAndPermissions.RepairIncomingReceives.ensure,
      roleAndPermissions.RepairServiceOrders.view,
      roleAndPermissions.RepairServiceOrders.update,
    ],
    type: "group",
    children: [
      {
        key: "return-operations",
        label: "Return Operations",
        icon: <TbTruckReturn />,
        requiredPermissions: [
          roleAndPermissions.MiddlewareReturns.view,
          roleAndPermissions.MiddlewareReturns.create,
          roleAndPermissions.MiddlewareReturns.update,
          roleAndPermissions.MiddlewareReceives.view,
          roleAndPermissions.MiddlewareReceives.update,
          roleAndPermissions.MiddlewareReceives.submit,
          roleAndPermissions.MiddlewareRefundSync.view,
          roleAndPermissions.MiddlewareRefundSync.resync,
        ],
        labelOnly: true,
        children: [
          {
            key: routes.RETURN_OPERATIONS_DASHBOARD.path,
            icon: <RiDashboardLine />,
            label: "Overview",
            requiredPermissions: [
              roleAndPermissions.MiddlewareReturns.view,
              roleAndPermissions.MiddlewareReceives.view,
              roleAndPermissions.MiddlewareRefundSync.view,
            ],
            openMenuKeys: ["return-operations"],
          },
          {
            key: routes.RETURN_OPERATIONS_RETURNS.path,
            icon: <RiArrowGoBackLine />,
            label: "Returns",
            requiredPermissions: [roleAndPermissions.MiddlewareReturns.view],
            openMenuKeys: ["return-operations"],
          },
          {
            key: routes.RETURN_OPERATIONS_RECEIVES.path,
            icon: <RiInboxArchiveLine />,
            label: "Receives",
            requiredPermissions: [roleAndPermissions.MiddlewareReceives.view],
            openMenuKeys: ["return-operations"],
          },
          {
            key: routes.RETURN_OPERATIONS_REFUND_SYNC.path,
            icon: <RiRefreshLine />,
            label: "Refund Sync",
            requiredPermissions: [roleAndPermissions.MiddlewareRefundSync.view],
            openMenuKeys: ["return-operations"],
          },
        ],
      },
      {
        key: "repair-orders-operations",
        label: "Repair Operations",
        icon: <GiAutoRepair />,
        requiredPermissions: [
          roleAndPermissions.RepairOrders.view,
      roleAndPermissions.RepairOrders.promote,
      roleAndPermissions.RepairOrders.retry,
      roleAndPermissions.RepairIncomingReceives.view,
      roleAndPermissions.RepairIncomingReceives.submit,
      roleAndPermissions.RepairIncomingReceives.ensure,
      roleAndPermissions.RepairServiceOrders.view,
      roleAndPermissions.RepairServiceOrders.update,
        ],
        labelOnly: true,
        children: [
          {
            key: routes.REPAIR_ORDERS_DASHBOARD.path,
            icon: <RiDashboardLine />,
            label: "Overview",
            requiredPermissions: [
              roleAndPermissions.RepairOrders.view,
              roleAndPermissions.RepairIncomingReceives.view,
              roleAndPermissions.RepairServiceOrders.view,
            ],
            openMenuKeys: ["repair-orders-operations"],
          },
          {
            key: routes.REPAIR_ORDERS_LIST.path,
            icon: <RiFileList3Line />,
            label: "Orders",
            requiredPermissions: [roleAndPermissions.RepairOrders.view],
            openMenuKeys: ["repair-orders-operations"],
          },
          {
            key: routes.REPAIR_ORDERS_INCOMING.path,
            icon: <RiInboxArchiveLine />,
            label: "Incoming Receives",
            requiredPermissions: [roleAndPermissions.RepairIncomingReceives.view],
            openMenuKeys: ["repair-orders-operations"],
          },
          {
            key: routes.REPAIR_ORDERS_SERVICE.path,
            icon: <RiToolsLine />,
            label: "Service Orders",
            requiredPermissions: [roleAndPermissions.RepairServiceOrders.view],
            openMenuKeys: ["repair-orders-operations"],
          },
        ],
      },
     
    ],
  },
  {
    icon: <MdOutlineInventory />,
    label: "Reports",
    requiredPermissions: [roleAndPermissions.Reports.viewCompatibility],
    type: "group",
    children: [
      {
        key: routes.REPORTS.path,
        icon: <RiFileChartLine />,
        label: "Reports",
        requiredPermissions: [roleAndPermissions.Reports.viewCompatibility],
      },
    ],
  },
  {
    icon: <MdOutlineInventory />,
    label: "CMS",
    requiredPermissions: [
      roleAndPermissions.PageManagement.view,
      roleAndPermissions.PageManagement.create,
      roleAndPermissions.PageManagement.update,
      roleAndPermissions.PageManagement.delete,
    ],
    type: "group",
    children: [
      {
        key: routes.CMSPAGE.path,
        // icon: <PiStackDuotone />,
        label: "CMS Pages",
        requiredPermissions: [
          roleAndPermissions.PageManagement.view,
          roleAndPermissions.PageManagement.create,
          roleAndPermissions.PageManagement.update,
          roleAndPermissions.PageManagement.delete,
        ],
      },
      {
        key: routes.BLOGS.path,
        // icon: <PiStackDuotone />,
        label: "Blogs",
        requiredPermissions: [
          roleAndPermissions.PageManagement.view,
          roleAndPermissions.PageManagement.create,
          roleAndPermissions.PageManagement.update,
          roleAndPermissions.PageManagement.delete,
        ],
      },
    ],
  },
];

export default menus;
